import { COLORS } from "~/utils";

export const RENT_COLOR = COLORS.lime_green;
export const FEES_COLOR = COLORS.forest_green;
export const REPAIRS_COLOR = COLORS.vibrant_pink;
export const LOST_RENT_COLOR = COLORS.warm_tangerine;
export const RENOVATION_COLOR = COLORS.coral_pink;
export const OCCUPIED_COLOR = COLORS.vibrant_green;
export const VACANT_COLOR = COLORS.red;
export const OFF_MARKET_COLOR = COLORS.grey;
export const OTHER_REVENUE_COLOR = COLORS.baby_blue;
export const STAY_REVENUE_COLOR = COLORS.light_blue;
export const TOTAL_REVENUE_COLOR = COLORS.turquoise;
export const TOTAL_EXPENSE_COLOR = COLORS.peach;
export const NET_COLOR = COLORS.yellow_green;
